// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fNOmHp1rKBQ2syiaaid9{flex-direction:column;padding:32px 20px 40px;display:flex}.sW9cCUDMgCMwLM9SIMB1{align-items:center;gap:16px;margin-top:48px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overviewPage": `fNOmHp1rKBQ2syiaaid9`,
	"cancelSection": `sW9cCUDMgCMwLM9SIMB1`
};
export default ___CSS_LOADER_EXPORT___;
